import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import PolicyManager from './PolicyManager';
import { integratedDclEnabled } from '../../features/useIntegratedDcl';

export default function IntegratedPolicyAction({ tenantId, insuranceEnabled, onPolicyChange, compact = false }) {
  const [open, setOpen] = useState(false);
  if (!integratedDclEnabled(tenantId, insuranceEnabled)) return null;
  return <>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, p: compact ? 0 : 2, mb: compact ? 0 : 2, bgcolor: '#fff', border: compact ? 0 : '1px solid #dce4f0', borderRadius: 2 }}>
      {!compact && <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}><ShieldOutlinedIcon color="primary" /><Box>
        <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#2F3D63' }}>Insurance policy and DCL assessment</Typography>
        <Typography sx={{ fontSize: 12, color: '#64748b', mt: .5 }}>Use existing company records. View a DCL status for policy criteria, evidence and missing inputs.</Typography>
      </Box></Box>}
      <Button variant="outlined" onClick={() => setOpen(true)} sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}>Add / Manage policy</Button>
    </Box>
    <PolicyManager tenantId={tenantId} open={open} onClose={() => setOpen(false)} onPolicyChange={onPolicyChange} />
  </>;
}
